export default __webpack_public_path__ + "static/media/steps-mobile-en.0b0b3427.svg";